import { render, staticRenderFns } from "./EventFieldContent.vue?vue&type=template&id=ef1db050"
import script from "./EventFieldContent.vue?vue&type=script&lang=js"
export * from "./EventFieldContent.vue?vue&type=script&lang=js"
import style0 from "./EventFieldContent.vue?vue&type=style&index=0&id=ef1db050&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports